import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import './ViewGroup.css';
import { CreateGroup } from './CreateGroup';
import RemoveGroup from './RemoveGroup';
import config from '../../constant/config';
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export class ViewGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hubUsers: this.props.users,
      showGroups: true,
      showCreateGroup: false,
      listOfGroups: [],
      selectedGroupName: '',
      courses: '',
      users: '',
      createStatus: true,
      showModal: false,
      modalContent: null,
      editGroup: false,
      groupInvitationToken: null,
      sortOrder: 'desc',
      searchInput: ''
    };
  }

  async componentDidMount() {
    const res = await fetch(
      `${config.apiURL}/hub/${this.props.hubId}/getCourses`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      }
    );
    if (res.status == 200) {
      const coursesInHub = await res.json();
      this.setState({
        coursesInHub: coursesInHub
      });
    }

    await this.fetchGroups();

//The below commented piece of code is inside the fetchGroups method as this is re-used

   /* const resGroups = await fetch(
      `${config.apiURL}/hub/${this.props.hubId}/getAllGroupsDetail`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      }
    );
    if (res.status == 200) {
      const groups = await resGroups.json();
      this.setState({
        listOfGroups: groups
      });
    }*/
  }

  onClickCreateGroup() {
    this.setState({
      showGroups: false,
      showCreateGroup: true,
      createStatus: true,
      courses: [],
      users: [],
      selectedGroupName: 'Group Name'
    });
  }

  onClickGroup = (groupId) => {
    const group = this.state.listOfGroups.find((group) => group.id === groupId);
    this.setState({
      showGroups: false,
      showCreateGroup: true,
      selectedGroupName: group.title,
      selectedGroupId: group.id,
      courses: group.courses,
      users: group.users,
      createStatus: false,
      groupInvitationToken: group.groupInvitationToken
    });
  };

  onClickQuizResults() {}
  
  OnClickBack = () => {
    this.setState({
      showGroups: true,
      showCreateGroup: false
    });
  };
  async deleteGroup(groupId) {
    try {
      const res = await fetch(
        `${config.apiURL}/hub/${this.props.hubId}/group/${groupId}`,
        {
          method: 'DELETE',
          credentials: 'include',
          headers: { 'content-type': 'application/json' }
        }
      );
      if (res.status !== 200) {
        throw new Error('unable to delete group');
      } else {
        const updatedGroups = this.state.listOfGroups.filter(
          (group) => group.id !== groupId
        );
        this.setState({
          listOfGroups: updatedGroups,
          showModal: false
        });
      }
    } catch (err) {
      console.error(err.message);
    }
  }
fetchGroups = async() => {
   const resGroups = await fetch(
      `${config.apiURL}/hub/${this.props.hubId}/getAllGroupsDetail`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      }
    );
    if (resGroups.status == 200) {
      const groups = await resGroups.json();
      this.setState({
        listOfGroups: groups
      });
    }

}
  closeModal = () => {
    this.setState({
      showModal: false
    });
  };

  renderRemoveConfirmGroup(groupId) {
    this.setState({
      showModal: true,
      modalContent: (
        <RemoveGroup
          closeModal={() => this.closeModal()}
          removeGroup={() => this.deleteGroup(groupId)}
        />
      )
    });
  }

     async downloadReport(groupId,groupTitle) {
          
          
    try {
      const res = await fetch(
        `${config.apiURL}/group/report/analytics/${groupId}`,
        {
          credentials: 'include',
          method: 'GET',
          headers: { 'content-type': 'application/json' }
        }
      );

      if (!res.ok) {
        const errorText = await res.text();
        console.error('Server returned error:', errorText);
        alert(`Failed to load report (HTTP ${res.status})`);
        return;
      }
      const reportData = await res.json();

      if (!reportData || reportData.length === 0) {
        alert('No data available for this report.');
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(reportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

      XLSX.writeFile(workbook, `Group_${groupTitle}_Report.xlsx`);
    } catch (error) {
      console.error('Error downloading report:', error);
      alert('Failed to download report. ');
    }
  
  
      };

  handleSortByName = () => {
    const { listOfGroups, sortOrder } = this.state;

    const sortedGroups = [...listOfGroups].sort((a, b) => {
      const elementA = a.title.toLowerCase();
      const elementB = b.title.toLowerCase();

      if (sortOrder === 'asc') {
        return elementA.localeCompare(elementB);
      } else {
        return elementB.localeCompare(elementA);
      }
    });

    this.setState({
      listOfGroups: sortedGroups,
      sortOrder: sortOrder === 'asc' ? 'desc' : 'asc'
    });
  };
  handleSearch = (event) => {
    this.setState({ searchInput: event.target.value });
  };

  render() {
    return (
      <div className="main-group-container">
        {this.state.showGroups && (
          <div>
            <div className="header-container">
              <div className="main-heading">Groups</div>
              <div className="create-button-container">
                <Button
                  className="create-group-button"
                  onClick={() => {
                    this.onClickCreateGroup();
                  }}
                >
                  Create Group
                </Button>
              </div>
            </div>
            <div className="group-table">
              <Row className="group-row">
                <Col
                  className="group-col"
                  style={{
                    display: 'flex',
                    fontWeight: 'bold',
                    justifyContent: 'space-between',
                    fontSize: '20px'
                  }}
                >
                  <div className="group-title" style={{ paddingTop: '5px' }}>
                    Name
                  </div>
                  <div className="searchbox-sort" style={{ display: 'flex' }}>
                    <div
                      style={{
                        display: 'flex',

                        position: 'relative',
                        width: '300px'
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search Groups"
                        value={this.state.searchInput}
                        onChange={this.handleSearch}
                        style={{
                          marginTop: '5px',
                          fontSize: '16px',
                          width: '300px',
                          borderRadius: '20px',
                          paddingLeft: '20px',
                          outline: 'none'
                        }}
                      />
                      {this.state.searchInput && (
                        <i
                          className="bi bi-x-circle-fill"
                          onClick={() => this.setState({ searchInput: '' })}
                          style={{
                            position: 'absolute',
                            right: '8px',
                            top: '57%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#9a9799ff',
                            fontSize: '20px'
                          }}
                          title="Clear search"
                        >
                          {' '}
                        </i>
                      )}
                    </div>
                    <Button
                      variant="link"
                      onClick={this.handleSortByName}
                      style={{
                        //  padding: '0 5px',
                        fontSize: '25px',
                        fontWeight: 'bold',
                      color:'#14B4C8',
                      

                      }}
                    >
                      <i
                        className={`bi ${
                          this.state.sortOrder === 'asc'
                            ? 'bi-sort-alpha-up'
                            : 'bi-sort-alpha-down'
                        }`}
                        //  style={{ }}
                      ></i>
                    </Button>
                  </div>
                </Col>
                <Col className="group-col"></Col>
              </Row>
              {this.state.listOfGroups
                .filter((group) =>
                  group.title
                    .toLowerCase()
                    .includes(this.state.searchInput.toLowerCase())
                )
                .map((group) => (
                  <>
                    <Row className="group-row" key={group.id}>
                      <Col className="group-col">
                        <div className="group-name-container">
                          <Button
                            className="group-name"
                            style={{ paddingLeft: '20px' }}
                            onClick={() => {
                              this.onClickGroup(group.id);
                            }}
                          >
                            {group.title}
                          </Button>
                        </div>
                      </Col>
                      <Col className="group-col">
                        <div className="quiz-button-container">
                          {/* <Button className='quiz-results-button' onClick={this.onClickQuizResults()}>Quiz Results</Button> */}
                          <Button
                            style={{
                              backgroundColor: '#14B4C8',
                              borderRadius: '18px',
                              color: 'white'
                            }}
                            onClick={() => {
                              this.downloadReport(group.id, group.title);
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faDownload}
                              style={{ marginRight: '8px' }}
                            />
                            Group Report
                          </Button>
                          {/* <Button className='warning-button' style={{backgroundColor:'#14B4C8'}} onClick={() => {  }}>Download Report</Button>  */}
                          <Button
                            className="warning-button"
                            onClick={() =>
                              this.renderRemoveConfirmGroup(group.id)
                            }
                          >
                            Delete Group
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </>
                ))}
            </div>
          </div>
        )}
        {this.state.showCreateGroup && (
          <CreateGroup
            OnClickBack={this.OnClickBack}
            create={this.state.createStatus}
            groupName={this.state.selectedGroupName}
            groupId={this.state.selectedGroupId}
            courses={this.state.courses}
            users={this.state.users}
            hubUsers={this.state.hubUsers}
            hubId={this.props.hubId}
            user={this.props.user}
            coursesInHub={this.state.coursesInHub}
            groupInvitationToken={this.state.groupInvitationToken}
            listOfGroups={this.state.listOfGroups}
            OnGroupSaved={() => this.fetchGroups()}
          ></CreateGroup>
        )}
        <Modal show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header closeButton />
          {this.state.modalContent}
        </Modal>
      </div>
    );
  }
}

export default withRouter(ViewGroup);
